// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ErrorDiscriminationStrategy = {
    statusCode: () => {
        return {
            type: "statusCode",
            _visit: function (visitor) {
                return FernIr.ErrorDiscriminationStrategy._visit(this, visitor);
            },
        };
    },
    property: (value) => {
        return Object.assign(Object.assign({}, value), { type: "property", _visit: function (visitor) {
                return FernIr.ErrorDiscriminationStrategy._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "statusCode":
                return visitor.statusCode();
            case "property":
                return visitor.property(value);
            default:
                return visitor._other(value);
        }
    },
};
